import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from "@angular/platform-browser";
import { Subject } from "rxjs";
import { BaseFormModule } from "src/app/pages/shared/base/modules/base-form.module";




@Component({
    selector: 'app-short-link-report-dialog',
    templateUrl: './short-link-report-dialog.component.html',
    styleUrls: ['./short-link-report-dialog.component.scss'],
    imports: [BaseFormModule, MatDialogModule]
})
export class ShortLinkReportDialogComponent {
  url: any;
  protected onDestroy$ = new Subject<void>();

  constructor(
    private sanitizer: DomSanitizer,
    protected dialogRef: MatDialogRef<ShortLinkReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.url = this.sanitizer.bypassSecurityTrustHtml(
      `<iframe height="100%" width="100%" scrolling="yes" src="${data}"></iframe>`,
    );

  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  unSubs() {
    this.onDestroy$.next();
  }


}
